import React from 'react';
import HeroSlider from '../components/HeroSlider';
import './Home.css';

const Home = () => (
  <div className="home-page">
    <HeroSlider />
  </div>
);

export default Home;
